<template>
  <div class="d-flex flex-row justify-center align-center">
    <v-card width="70%" min-width="230" elevation="0" class="align-self-center">
      <v-card-text>
        <v-form>
          <p class="title-header">เข้าสู่ระบบ</p>   
          <v-divider></v-divider>  
          <br>
          <p class="title-input">ชื่อผู้ใช้</p>   
          <v-text-field 
            id="username"
            v-model="username"
            placeholder="กรอกชื่อผู้ใช้"
            name="login"
            required
            single-line
            outlined
            hide-details
            dense
            @keyup.enter="login"
          ></v-text-field>
          <p class="title-input">รหัสผ่าน</p>   
          <v-text-field
            v-model="password"
            id="password"
            placeholder="กรอกรหัสผ่าน"
            name="password"
            type="password"
            required
            single-line
            outlined
            hide-details
            dense
            @keyup.enter="login"
          ></v-text-field>
        </v-form>
      </v-card-text> 
      <v-card-actions>
        <v-btn large :block="true" color="primary" @click="login()" >เข้าสู่ระบบ</v-btn>
        <!-- <v-btn large :block="true" color="primary" @click="test()" >test</v-btn> -->
      </v-card-actions>
      <div class="d-flex flex-row justify-center" v-if="errorMessage != ''" style="color:red">
        ชื่อผู้ใช้หรือรหัสผ่านไม่ถูกต้อง
      </div>
    </v-card>
    <v-snackbar
      v-model="snackbar"
    >
      {{ snackbar_text }}

      <template v-slot:action="{ attrs }">
        <v-btn
          color="pink"
          text
          v-bind="attrs"
          @click="snackbar = false"
        >
          ปิด
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
  export default {
    data: () => ({
      username: '',
      password: '',
      snackbar: false,
      snackbar_text: 'username/password ไม่ถูกต้อง',
      isloading: false,
      errorMessage: '',
    }),
    mounted () {
      console.log('in login')
    },
    methods: {
      getSecondsToTomorrow() {
        let now = new Date();
      
        // tomorrow date
        let tomorrow = new Date(now.getFullYear(), now.getMonth(), now.getDate()+1);
      
        let diff = tomorrow - now; // difference in ms
        return Math.round(diff / 1000); // convert to seconds
      },
      async login () {
        this.isloading = true
        console.log('start login ')
        const login_result = await this.$store.dispatch('login', {
          username: this.username,
          password: this.password
        })

        if (login_result == null) {
          this.snackbar = true
        }

        this.$cookie.set('user', JSON.stringify(login_result), { expires: '1D'})

        for (let i = 0; i < login_result.roles.length; i++) {
          console.log(login_result.roles[i])
          if (login_result.roles[i] == 'user' || login_result.roles[i] == 'sale') {
            this.$router.push('/sale')
          } else if (login_result.roles[i] == 'web_admin') {
            this.$router.push('/admin')
          } else if (login_result.roles[i] == 'admin_page') {
            this.$router.push('/createTransaction')
          }
          else {
            console.log('no role')
          }
        }
        this.isloading = false
      }
    }
  }
</script>